"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var Icon = function Icon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "m16.35 13.593 1.91 7.128A15.884 15.884 0 0 1 12 22c-2.223 0-4.338-.457-6.26-1.28l1.91-7.127A8.697 8.697 0 0 1 4.301 2l5.886 8.406h3.624L19.698 2a8.697 8.697 0 0 1-3.347 11.593z"
  }));
};
Icon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#CrateAsset',
    assetType: 'Crate'
  },
  owner: {
    gusTeam: 'MS Mule API Gateway & API Tooling',
    gusTeamLink: 'https://gus.lightning.force.com/lightning/r/ADM_Scrum_Team__c/a00AH000000in0QYAQ/view'
  },
  name: 'Crate',
  pluralName: 'Crates',
  featureFlag: 'crate-enabled',
  publication: {
    inferredBy: [{
      classifiers: ['rust-crate'],
      typeProperty: 'crate'
    }],
    files: [{
      id: 'crate',
      classifier: 'rust-crate',
      packaging: 'crate'
    }, {
      id: 'metadata',
      classifier: 'crate-metadata',
      packaging: 'json'
    }],
    minimumInputSets: [{
      files: ['crate', 'metadata']
    }]
  },
  portal: {
    icon: Icon,
    color: '#0176d3',
    files: [{
      fileId: 'crate',
      label: 'Crate'
    }]
  },
  keywords: ['crate']
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map